import { api } from "./client";

export interface AlertChannels {
  email: {
    recipients: string[];
    severityFilter: "info" | "warning" | "critical" | null;
  } | null;
  gchat: {
    webhookConfigured: boolean;
    severityFilter: "info" | "warning" | "critical" | null;
  } | null;
}

export interface DispatchAttempt {
  channel: string;
  recipient: string | null;
  status: "sent" | "failed" | "skipped";
  responseCode: number | null;
  errorMessage: string | null;
}

export interface AlertDeliveryRow {
  id: string;
  metricAlertId: string;
  channel: string;
  recipient: string | null;
  status: string;
  responseCode: number | null;
  errorMessage: string | null;
  attemptedAt: string;
}

export const alertChannelsApi = {
  get: (companyId: string) =>
    api.get<AlertChannels>(`/companies/${companyId}/alert-channels`),

  save: (
    companyId: string,
    body: {
      email?: {
        recipients?: string[];
        severityFilter?: "info" | "warning" | "critical";
      };
      gchat?: {
        webhookUrl?: string;
        severityFilter?: "info" | "warning" | "critical";
      };
    },
  ) =>
    api.put<{ ok: boolean; channels: AlertChannels }>(
      `/companies/${companyId}/alert-channels`,
      body,
    ),

  test: (
    companyId: string,
    severity: "info" | "warning" | "critical" = "warning",
  ) =>
    api.post<{ alertId: string; result: { alertId: string; attempts: DispatchAttempt[] } }>(
      `/companies/${companyId}/alert-channels/test`,
      { severity },
    ),

  deliveries: (companyId: string) =>
    api.get<AlertDeliveryRow[]>(`/companies/${companyId}/alert-deliveries`),
};
